module.exports = __webpack_public_path__ + "0e3bf4b30040397edb4c42775cc03afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/edit-black.png
// module id = 211
// module chunks = 0